module.exports = "<div class=\"ibox-tools dropdown\"\n     dropdown>\n    <a ng-click=\"showhide()\"> <i class=\"fa fa-chevron-up\"></i></a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/iboxTools/view.html
// module id = 946
// module chunks = 0